import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError, map, tap, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ILogEntry } from 'src/app/interfaces/ilog-entry';

@Injectable({
  providedIn: 'root',
})
export class LogApiService {
  backendUrl: string = environment.backendUrl;

  constructor(private http: HttpClient) {}

  saveLogs(logEntries: ILogEntry[]): Observable<string> {
    if (!logEntries || logEntries.length === 0) {
      return new Observable((observer) => observer.complete());
    }

    return this.http
      .post<string>(`${this.backendUrl}/log/submitLogs`, logEntries, {
        responseType: 'text' as 'json',
      })
      .pipe(
        map((result) => result),
        tap((res) => {
          const outcome = res ? 'sent' : 'failed to send';
          // console.log(`Log API: ${outcome} ${logEntries.length} log(s)`);
        }),
        catchError((error: HttpErrorResponse) => {
          console.error('Log API Error:', error);
          return throwError(() => error);
        })
      );
  }
}
